
import {defineComponent} from "vue";

export default defineComponent({
  name: 'PrivacyPolicyPage',
  props: {
    serviceCode: {
      type: String,
      required: true
    }
  },
  setup: function () {
    return {}
  }
})
